module.exports = __webpack_public_path__ + "img/edge3.765fd9cb.png";